<template>
  <div class="agreement-page">
    <div class="agreement-header">
      <div class="header-top">
        <el-button icon="el-icon-close" type="text" class="close-btn" @click="closePage">关闭</el-button>
      </div>
      <h1>{{ agreementData.title }}</h1>
      <div class="version-info">
        <span>版本：{{ agreementData.version }}</span>
        <span class="divider">|</span>
        <span>更新时间：{{ formatTime(agreementData.updateTime) }}</span>
      </div>
    </div>
    <div class="agreement-body" v-loading="loading">
      <div v-html="agreementData.content"></div>
    </div>
  </div>
</template>

<script>
import loginMock from '@/assets/js/loginMock'

export default {
  name: 'Agreement',
  data() {
    return {
      type: this.$route.query.type || 'agreement',
      loading: false,
      agreementData: {
        title: '',
        version: '',
        updateTime: Date.now(),
        content: ''
      }
    }
  },
  created() {
    this.getAgreementData()
  },
  methods: {
    async getAgreementData() {
      this.loading = true
      try {
        const res = loginMock.getAgreementByType(this.type)
        if (res.code === 1) {
          this.agreementData = res.data
        }
      } finally {
        this.loading = false
      }
    },
    closePage() {
      // 如果是新窗口打开，关闭窗口；否则返回上一页
      if (window.opener) {
        window.close()
      } else {
        this.$router.go(-1)
      }
    },
    formatTime(timestamp) {
      if (!timestamp) return '-'
      const date = new Date(timestamp)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}/${month}/${day}`
    }
  }
}
</script>

<style lang="less" scoped>
.agreement-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);
  padding: 0;
  box-sizing: border-box;

  .agreement-header {
    background: linear-gradient(135deg, @color-primary 0%, @color-primary-dark 100%);
    padding: 24px 30px 30px;
    margin-bottom: 0;
    box-shadow: 0 4px 20px rgba(43, 119, 255, 0.3);
    position: sticky;
    top: 0;
    z-index: 100;

    .header-top {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 16px;
      
      .close-btn {
        color: rgba(255, 255, 255, 0.9);
        font-size: 14px;
        padding: 8px 16px;
        border-radius: 20px;
        transition: all 0.3s ease;
        
        &:hover {
          background: rgba(255, 255, 255, 0.15);
          color: #fff;
        }
        
        i {
          margin-right: 4px;
        }
      }
    }

    h1 {
      font-size: 28px;
      font-weight: 600;
      color: #fff;
      margin: 0 0 12px;
      text-align: center;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .version-info {
      text-align: center;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.85);
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 12px;
      
      .divider {
        opacity: 0.5;
      }
    }
  }

  .agreement-body {
    background: #fff;
    padding: 40px 60px;
    margin: 24px;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    min-height: calc(100vh - 200px);
  }
}

// 协议内容样式
::v-deep .agreement-content {
  h1 {
    font-size: 26px;
    font-weight: 600;
    color: #222;
    text-align: center;
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 2px solid @color-primary;
    display: none; // 已在header中显示
  }

  h2 {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-top: 32px;
    margin-bottom: 16px;
    padding-left: 12px;
    border-left: 4px solid @color-primary;
    background: linear-gradient(90deg, rgba(43, 119, 255, 0.08) 0%, transparent 100%);
    padding: 10px 12px;
    border-radius: 0 6px 6px 0;
  }

  h3 {
    font-size: 16px;
    font-weight: 600;
    color: #444;
    margin-top: 24px;
    margin-bottom: 12px;
    padding-left: 8px;
    border-left: 3px solid @color-primary-light;
  }

  p {
    font-size: 15px;
    line-height: 1.9;
    color: #555;
    margin-bottom: 14px;
    text-align: justify;
    text-indent: 2em;
  }

  .update-time {
    text-align: center;
    color: #999;
    font-size: 13px;
    margin-bottom: 30px;
    display: none; // 已在header中显示
  }

  .contact-info {
    color: @color-primary;
    font-size: 14px;
    margin-top: 8px;
    text-indent: 0;
    padding-left: 0;
    
    &:first-of-type {
      margin-top: 24px;
      padding-top: 20px;
      border-top: 1px dashed #e0e0e0;
    }
  }
}

// 移动端适配
@media screen and (max-width: 800px) {
  .agreement-page {
    .agreement-header {
      padding: 16px 20px 20px;
      
      .header-top {
        margin-bottom: 12px;
      }

      h1 {
        font-size: 22px;
      }

      .version-info {
        font-size: 12px;
        flex-wrap: wrap;
        gap: 8px;
      }
    }

    .agreement-body {
      margin: 16px;
      padding: 24px 20px;
      border-radius: 8px;
    }
  }

  ::v-deep .agreement-content {
    h2 {
      font-size: 16px;
      padding: 8px 10px;
    }

    h3 {
      font-size: 15px;
    }

    p {
      font-size: 14px;
      line-height: 1.8;
      text-indent: 2em;
    }
  }
}
</style>
